import HTTP from '../common/http-common';
const END_POINT = '/stock-consumable';

const getHistory = (consumableCode, branchCode) => HTTP.get(END_POINT + "/history", {
    cache: false,
    params: {
        branchCode:  branchCode,
        consumableCode: consumableCode
    }
});

const getConsumable = (id) => HTTP.get(END_POINT + id);
const getStockConsumable = (id) => HTTP.get(END_POINT + "/stock/" + id, { cache: false });

const listStockConsumable = (branchCode, searchType, searchValue) => HTTP.get(END_POINT, {
    cache: false,
    params: {
        branchCode:  branchCode,
        searchType: searchType,
        searchValue: searchValue
    }
});

const listStockConsumableByReceiveNo = (branchCode, dateFrom, dateTo, receiveNo) => HTTP.get(END_POINT + "/list", {
    cache: false,
    params: {
        branchCode:  branchCode,
        dateFrom: dateFrom,
        dateTo: dateTo,
        receiveNo: receiveNo
    }
});
const listStockConsumableOffice = 
    (branchCode, searchType, searchValue, dateFrom, dateTo) => HTTP.get(END_POINT +  "/listStockOffice/" + branchCode + "?" + "dateFrom=" + dateFrom + "&dateTo=" + dateTo + "&searchType=" + searchType + "&searchValue=" + searchValue);

const updateStockConsumableReceive = (data) => HTTP.post(END_POINT + "/update/" + data.stockConsumableId, {
        branchCode: data.branchCode,
        receiveNo: data.receiveNo,
        docDate: data.docDate,
        receiveDate: data.receiveDate,
        percentDiscount: data.percentDiscount,
        receiver: data.receiver,
        details: data.details,
        withdrawNo: data.withdrawNo,
        withdrawDate: data.withdrawDate,
        stockOfficer: data.stockOfficer,
        totalAmount: data.totalAmount,
        status: data.status
    });

    // stock receive
const insertStockConsumable = (data) => HTTP.post(END_POINT + "/insert", {
    branchCode: data.branchCode,
    receiveNo: data.receiveNo,
    docDate: data.docDate,
    receiveDate: data.receiveDate,
    percentDiscount: data.percentDiscount,
    receiver: data.receiver,
    details: data.details,
    withdrawNo: data.withdrawNo,
    withdrawDate: data.withdrawDate,
    stockOfficer: data.stockOfficer,
    totalAmount: data.totalAmount,
    status: data.status
});

const updateStockConsumable = (data) => HTTP.post(END_POINT + "/update", {
    stockConsumableId: data.stockConsumableId,
    stockConsumableDetailId: data.stockConsumableDetailId,
    branchCode: data.branchCode,
    unitPrice: data.unitPrice,
    consumableCode: data.consumableCode,
    qty: data.qty,
    transType: data.transType,
    remark: data.remark
});

const deleteDetailStockConsumable = (id) => HTTP.get(END_POINT + "/delete/" + id);
const deleteStockConsumable = (id) => HTTP.get(END_POINT + "/deleteStock/" + id);

export {
    getHistory,
    getConsumable,
    getStockConsumable,
    listStockConsumable,
    listStockConsumableByReceiveNo,
    listStockConsumableOffice,
    insertStockConsumable,
    updateStockConsumable,
    updateStockConsumableReceive,
    deleteDetailStockConsumable,
    deleteStockConsumable
}